import { Card, CardContent, Typography } from '@mui/material';
import { useContext, useState } from 'react';
import BackNavigationButton from '../../components/common/BackNavigationButton';
import PageContainer from '../../components/common/PageContainter';
import StyledCardTitleBar from '../../components/common/StyledCardTitleBar';
import SextforceCaptionsManager from '../../components/services/sextforce/SextforceCaptionsManager';
import useSubscriber from '../../hooks/useSubscriber';
import { SettingsContext } from '../../store/SettingsContext';

const ManageCaptions = () => {
    const settingsContext = useContext(SettingsContext);
    const { data: subscriber } = useSubscriber();
    const [isLoading, setIsLoading] = useState(false);

    return (
        <PageContainer
            sx={{
                height: 'calc(100dvh - 64px)',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}
        >
            <Typography variant="h5" sx={{ mb: 0.5, flexShrink: 0 }}>
                <BackNavigationButton url={`/subscribers/${subscriber?._id}/${settingsContext.services.inventory.homeUrl}`} /> Manage
                Captions for {subscriber?.username}
            </Typography>
            <Card sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                <StyledCardTitleBar title="Manage Captions" isLoading={isLoading} />
                <CardContent
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        px: { xs: 1.5, sm: 2 },
                        pt: 1,
                    }}
                >
                    <SextforceCaptionsManager onLoadingChange={setIsLoading} />
                </CardContent>
            </Card>
        </PageContainer>
    );
};

export default ManageCaptions;
